var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-portfolio-tag-item",class:{
        'user-portfolio-tag-item--selected': _vm.selected,
        'user-portfolio-tag-item--outline': _vm.outline,
    },style:({
        '--fill_color': `#${_vm.catalogItem.meta.fill_color}`,
        '--text_color': `#${_vm.catalogItem.meta.text_color}`,
    }),on:{"click":_vm.click}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"6","height":"6","viewBox":"0 0 6 6","fill":"none"}},[_c('circle',{attrs:{"cx":"3","cy":"3","r":"3"}})]),_c('span',[_vm._v(_vm._s(_vm.catalogItem.field_value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }